module.exports = __webpack_public_path__ + "static/media/SFTM16.1a294eb8.jpg";